<template>
  <section class="screen">




          <div class="page-view">
            <div class="page-view__options" @click="timeline = true; actions = false">
              <span class="page-view__text" :class="{'page-view__active-text' : timeline}">My Categories</span>
            </div>
            <div class="page-view__options" @click="actions = true; timeline = false">
              <span class="page-view__text" :class="{'page-view__active-text' : actions }">My Services</span>
            </div>

          </div>


        <template v-if="timeline">
            <div class="service-container">
                <template v-for="(items, idx) in serviceCategory">
                <input type="text" class="service-input"  :key="idx" v-model="items.title">
                <input type="text" class="service-code" :key="idx" v-model="items.code">
                </template>
            </div>
            <input type="text" placeholder="add service category" v-model="serviceCategoryTitle">
            <input type="text" placeholder="service code" v-model="serviceCategoryCode">
            <div @click="pushServiceCategory()" class="submit">Add Category</div>

        </template>

        <template v-if="actions">

            <div class="service-container">
                <template v-for="(items, idx) in services">
                    <div class="service" :key="idx">

                        <input type="text" class="service-input" v-model="items.title">
                        <input type="text" class="service-code" v-model="items.code">
                        <input type="number" class="service-price" v-model="items.price">

                        <div class="input service-tags">


                          <div @click="makeTagsActive(idx)" type="text" class="service-tags" placeholder="Categories">
                            <template v-if="items.categoryTags.length === 0">
                              Add Category
                            </template>
                            <div class="service-tags__item" v-for="(list, id) in items.categoryTags" :key="id">{{list}}</div>
                          </div>

                        </div>

                        <div class="service-options" :key="idx" v-if="services[idx].active">
                            <div class="service-options__item" v-for="(display, id) in serviceCategory" :key="id" @click="addCategory(display, idx, items.id)">{{display.title}}</div>
                        </div>

                    </div>


                </template>
            </div>
            <input type="text" placeholder="Add Service Category" v-model="serviceTitle">
            <input type="text" placeholder="Service Code" v-model="serviceCode">
            <input type="number" placeholder="Service Price" v-model="servicePrice">
            <!-- <input type="text" placeholder="Category Tags" v-model="serviceTags"> -->
            <div @click="pushService()" class="submit">Add Category</div>

      </template>

      <!-- </div> -->







  </section>

</template>
<script>
import { Carousel, Slide } from 'vue-carousel'
import { page } from 'vue-analytics'
import AOS from '../main'
import { firestore } from "../main";
import * as firebase from "firebase";
import { mapMutations, mapGetters } from 'vuex'
import router from '../router';



export default {
  name: 'heroSection',
  data () {
    return {
        serviceCategoryTitle: null,
        serviceCategoryCode: null,
        serviceCategory: {},
        services: {},
        serviceTitle: null,
        serviceCode: null,
        servicePrice: null,
        user: {},
        cards: {},
        categoryTags: [],
        filter: '',
        timeline: true,
        actions: false,
        // tagsActive: {
        //     0: false,
        //     1: false
        // },
        activePage: null
    }
  },
  watch: {
    $route (to, from){
    }
  },
  methods: {
    addCategory(payload, idx, id) {
        // this.service.category 
        this.services[idx].categoryTags.push(payload.title)
        firestore.collection('services').doc(id).update({
          categoryTags: firebase.firestore.FieldValue.arrayUnion(payload.title)
        })
        // .then((data) => {
        //   firestore.collection('serviceCategory').doc(data.id).update({
        //     id: data.id
        //   })
        // })
        

        for (var items in this.services) {
            this.services[items].active = false
          }
        
    },
    makeTagsActive(payload){

        this.services[payload].active = !this.services[payload].active

        for (var items in this.services) {
          if (items != payload) {
            this.services[items].active = false
          }
        }

    },
    pushServiceCategory(){

        const payload = {
            title: this.serviceCategoryTitle,
            code: this.serviceCategoryCode,
            active: false
        }
        firestore.collection('serviceCategory').add(payload)
        .then((data) => {
          firestore.collection('serviceCategory').doc(data.id).update({
            id: data.id
          })
        })
    },
    pushService(){

        const payload = {
            title: this.serviceTitle,
            code: this.serviceCode,
            active: false,
            price: this.servicePrice,
            categoryTags: []
        }
        firestore.collection('services').add(payload)
        .then((data) => {
          firestore.collection('services').doc(data.id).update({
            id: data.id
          })
        })
    },
    appointment(payload){
      // this.$store.dispatch("options");
      this.$store.state.activePatient.payload = payload
      this.$store.state.activePatient.active= true
      this.$router.push('/appointment')
    },
    pushCard(payload, user) {
      this.$store.state.activePatient.payload = user
      this.$store.state.activePatient.active= true 
      this.$router.push('/card/' +  payload)
    },
    filterCat(payload) {
      return this.filter == payload
      ? this.filter = ''
      : this.filter = payload
    },
    radar(payload){
      // this.$store.dispatch("options");
      this.$store.state.activePatient.payload = payload
      this.$store.state.activePatient.active= true
      this.$router.push('/dental-radar')
    },
    messageUser(payload) {
      this.$router.push('/messages/' + payload.uid)
    },
    assignBalance(payload) {
      this.$store.state.activePatient.payload = payload
      this.$store.state.activePatient.active= true
      this.$router.push('/assign-balance')
    }
  },
  firestore() {
    this.activePage  = this.$route.path.split('/user/')[1]

    return {
    //   user: firestore.collection('users').doc(this.activePage),
    //   cards: firestore.collection('cards').where("uid", "==", this.activePage).orderBy('createdAt', 'desc'),
      serviceCategory: firestore.collection('serviceCategory'),
      services: firestore.collection('services')
  }
},
}
</script>

<style lang="scss" scoped>



  $break-small: 900px;
  $brandColor: #29aad0;
  $brandColorTwo: #70c8df;
  $accentColor: #de7c5e;

  .input {
    font-family: "source sans pro", sans-serif;
    letter-spacing: 2px;
    font-weight: lighter;
    color: #fff;
    background: transparent;
    border: 1px solid #fff;
    // position: fixed;

    border-radius: 50px;
    font-size: 18px;
    margin: 10px auto;
    // margin-left: -45%;
    outline: 0;
    padding: 15px 7px 15px 25px;
    width: 90%;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-shadow: 0 1px 0 rgba(0,0,0,0.03) inset;
    background-size: 40px 40px;

  }

input {
    font-family: "source sans pro", sans-serif;
    letter-spacing: 2px;
    font-weight: lighter;
    color: #fff;
    background: transparent;
    border: 1px solid #fff;
    // position: fixed;

    border-radius: 50px;
    font-size: 18px;
    margin: 10px auto;
    // margin-left: -45%;
    outline: 0;
    padding: 15px 7px 15px 25px;
    width: 90%;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-shadow: 0 1px 0 rgba(0,0,0,0.03) inset;
    background-size: 40px 40px;

    &::placeholder {
        color: #fff;
    }
}
    .category {
        border-radius: 0;
        margin: 0;
        width: 70%;
    }
    .service-input {
        border-radius: 0;
        margin: 0;
        width: 70%;
    }
    .service-code {
        width: 30%;
        border-radius: 0;
        margin: 0;
    }
    .service-price {
        width: 30%;
        border-radius: 0;
        margin: 0;
    }
    .service-tags {
        width: 70%;
        border-radius: 0;
        margin: 0;
        display: flex;
        flex-direction: row;
        flex-flow: wrap;
        &__item {
          margin: 2px;
          background-color: #fff;
          color: #000;
          padding: 5px 10px;
          font-size: 12px;
        }
    }
    .service-options {
        color: #fff;
        display: flex;
        width: 100%;
        flex-direction: column;
        background-color: rgba(0, 0, 0, 1);
        position: absolute;
        top: 100%;
        left: 0;
        z-index: 9999;

        &__item {
            width: 100%;
            padding: 10px 0;
            font-size: 18px;
            margin: 0 auto;
            text-align: left;
            padding-left: 20px;
            &:hover {
                // background-color: rgb(255, 255, 255);
            }
        }

    }
    // .service {
    //     color: #fff;
    //     text-align: left;
    //     width: 80%;
    //     padding: 5px 0;
    //     font-size: 18px;
    //     font-weight: bold;
    //     position: relative;
    //     margin: 1em 0;
    // }
    .service-container {
        margin: 2em auto;
        width: 80%;
        display: flex;
        flex-flow: wrap;
        position: relative;
    }
    .service {
        margin: 10px auto;
        width: 100%;
        display: flex;
        flex-flow: wrap;   
    }
      .submit {
        color: #de7c5e;
        border: 1px solid #de7c5e;
        width: 50%;
        margin: 1em auto 3em auto;
        padding: 5px 10px;
      }

  .st0{fill:none;stroke:#aaa;stroke-width:12;stroke-miterlimit:10;}

  .page-view {
    width: 90%;
    margin: 20px auto;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    &__text {
      color: #aaa;
    }
    &__active-text {
      color: #fff;
    }
    &__active-bg {
      stroke: #fff;
    }
    
    &__options {
      width: 50%;
      padding: 10px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
    }
    &__icon {
      width: 25px;
      margin-right: 10px;
    }
  }

  .action {
    background-color: transparent;
    border: 1px solid #de7c5e;
    color: #de7c5e;
    font-size: 8px;
    padding: 5px 10px;
    border-radius: 5px;
  }
  .filter {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: wrap;
    width: 100%;
    margin: 1em 0 2em 0;

    &__item {
      width: 30%;
      background-color: #70c8df;
      border: 1px solid #70c8df;
      margin: 1%;
      color: #fff;
      padding: 1% 0.5%;
      border-radius: 3px;
      text-transform: uppercase;
      font-weight: 500;
    }
    &__item-active {
      width: 30%;
      background-color: transparent;
      border: 1px solid #70c8df;
      margin: 1%;
      color: #fff;
      padding: 1% 0.5%;
      border-radius: 3px;
      text-transform: uppercase;
      font-weight: 500;
    }
  }

.options {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: wrap;

  .button {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border: 1px solid #70c8df;
    margin: 2vw;

    width: 40vw;
    height: 40vw;
    border-radius: 10px;
    font-size: 4vw;
    text-align: left;
    font-weight: bold;
  }

}

.screen {
    display: flex;
    flex-direction: column;
    position: relative;
    margin-top: 80px;
    padding: 20px 0 20px 0;
    width: 100%;
    align-items: center;
    height: auto;
    .tab {
        width: 90%;
        height: auto;
        padding: 20px 30px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        position: relative;
        align-items: left;
        justify-content: center;
        color: #fff;
        // background-color: #eee;
        border-left: 1px solid #fff;
        cursor: pointer;
        @media screen and (max-width: $break-small) {

        }

        h2 {
          font-size: 1.5vw;
          text-align: left;
          text-transform: uppercase;
          font-family: "futura", sans-serif;
          font-weight: 500;
          letter-spacing: 1px;
          @media screen and (max-width: $break-small) {
            font-size: 3vw;

          }
        }
 
        &__type {
            width: 15px;
            height: 15px;
            border-radius: 50%;
            position: absolute;
            top: calc(50% - 7.5px);
            left: -7.5px;
        }
        &__info {
          padding: 5px;
          border-radius: 15px;
          border-bottom-left-radius: 0;
          // background-color: #00d398;
        }

        &__media {
          width: 40%;
          right: 0;
          position: absolute;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 70%;
            border-radius: 10px;
          }
        }
            // sub settings of type
            .orange {
                background-color: $accentColor;
            }
            .yellow {
                background-color: #f8e85b;
            }
            .media {
                width: 30px;
                height: 30px;
                margin-left: -5px;
                img {
                    width: 20px;
                }
            }
            .grey {
                background-color: #ddd;
            }
        &__name {
            width: 70%;
            text-align: left;
            font-weight: 600;
            font-size: 16px;
        }
        &__description{
            width: 70%;
            text-align: left;
            font-weight: 300;
            font-size: 14px;
            font-style: italic;
            padding: 2px 0;
        }
    }
    
    // .tab {
    //     width: 90%;
    //     height: auto;
    //     padding: 20px 0;
    //     // background-color: #fff;
    //     // box-shadow: 1px 1px 2px rgb(195, 202, 211);
    //     border-radius: 5px;
    //     margin: 5px 0;
    //     display: flex;
    //     flex-direction: column;
    //     position: relative;
    //     align-items: center;
    //     justify-content: center;
    //     color: #777;

    //     hr {
    //         border: 1px solid #42455e;
    //         // border-top: 1px solid #42455e;

    //         color: #42455e;
    //         margin: 1em 0;
    //         width: 98%;
    //     }
 

    //     &__type {
    //         background-color: $accentColor;
    //         width: 15px;
    //         height: 15px;
    //         border-radius: 50%;
    //         position: absolute;
    //         top: calc(50% - 7.5px);
    //         left: 20px;
    //     }
    //         // type color
    //         .active {
    //             background-color: $brandColor
    //         }
    //         .inactive {
    //             background-color: #ddd
    //         }
    //     &__name {
    //         width: 70%;
    //         text-align: left;
    //         font-weight: 600;
    //         font-size: 16px;
    //     }
    //     &__description{
    //         width: 70%;
    //         text-align: left;
    //         font-weight: 300;
    //         font-size: 14px;
    //         font-style: italic;
    //         padding: 2px 0;
    //     }
    // }
    
}


  
</style>



// WEBPACK FOOTER //
// src/components/Services.vue